import { useMutation } from '@tanstack/react-query';
import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

import { createColorAsset } from '../../files';

const useCreateColor = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutate: handleCreateColor, isPending } = useMutation({
		mutationFn: (data) => createColorAsset(data),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { handleCreateColor, isPending };
};

export default useCreateColor;
